// src/components/ImageSwiper.js
import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const ImageSwiper = ({ isVisible }) => {
  // hold the swiper instance here
  const [swiperInstance, setSwiperInstance] = useState(null);

  useEffect(() => {
    if (!swiperInstance) return;           // not ready yet
    if (isVisible) {
      swiperInstance.autoplay.start();
    } else {
      swiperInstance.autoplay.stop();
    }
  }, [swiperInstance, isVisible]);

  return (
    <Swiper
      onSwiper={setSwiperInstance}          // gives you the Swiper instance
      modules={[Navigation, Pagination, Autoplay]}
      navigation
      pagination={{ clickable: true }}
      autoplay={{ delay: 2500, disableOnInteraction: false }}
      loop={false}                          // disable loop to suppress warning
      slidesPerView={1}                     // at least 1 slide
      className="hidden-swiper"
      style={{ width: 0, height: 0, overflow: 'hidden' }} // keep it off-screen
    >
      {/* Minimal slides so it's functional but invisible */}
      <SwiperSlide><div style={{ width: 1, height: 1 }} /></SwiperSlide>
      <SwiperSlide><div style={{ width: 1, height: 1 }} /></SwiperSlide>
      <SwiperSlide><div style={{ width: 1, height: 1 }} /></SwiperSlide>
    </Swiper>
  );
};

export default ImageSwiper;
